
import './App.css';
import Navbar from './components/rittik_navbar/Navbar';
import AllRoutes from './routs/AllRoutes';
import Footer from './components/sajan_loginfooter/Footer';
function App() {
  return (
    <div className="App">

      <Navbar/>
     <AllRoutes/>
     <Footer/>

    </div>
  );
  
  
}

export default App;
